import { render, staticRenderFns } from "./PesquisaPeriodicos.vue?vue&type=template&id=2ba74638&scoped=true"
import script from "./PesquisaPeriodicos.vue?vue&type=script&lang=js"
export * from "./PesquisaPeriodicos.vue?vue&type=script&lang=js"
import style0 from "./PesquisaPeriodicos.vue?vue&type=style&index=0&id=2ba74638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba74638",
  null
  
)

export default component.exports